import React, { Fragment, useEffect, useState } from "react";
import "./AddfolderPanel.css";
import Offcanvas from "react-bootstrap/Offcanvas";
import Form from "react-bootstrap/Form";
import AddBroker from "../AddBroker/AddBroker";
import AddFolderPanelService from "../../API/AddFolderPanel/AddFolderPanelService";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { fr } from "date-fns/locale";
import FilePageService from "../../API/FilePage/FilePageService";
import DashboardManagementService from "../../API/DashboardManagement/DashboardManagementService";
import Loading from "../../Common/Loading";

const AddfolderPanel = (props) => {
  const { t } = useTranslation();
  const {
    data,
    userRole,
    userName,
    userId,
    GetStatistics,
    GetTaskStatistics,
    GetAptAtotFromTransferHistory,
    FolderList,
    search,
    sort,
    currentPage,
    editUserStatus,
    file,
  } = props;

  const [isLoading, setIsLoading] = useState(false);

  const [show, setShow] = useState(false);
  const [uploadingDoc, setUploadingDoc] = useState(false);
  const [flashMessage, setFlashMessage] = useState({ type: "", message: "" });

  const [insurerOptions, setInsurerOptions] = useState([]);
  const [selectedInsurer, setSelectedInsurer] = useState(null);
  const [productOption, setProducOption] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [dynamicSteps, setDynamicSteps] = useState([]);
  const [currentStep, setCurrentStep] = useState(1);

  const [folderName, setFolderName] = useState("");
  const [contractNo, setContractNo] = useState("");
  const [policyholderName, setPolicyholderName] = useState("");
  const [estimatedStartDate, setEstimatedStartDate] = useState(null);
  const [estimatedCompletionDate, setEstimatedCompletionDate] = useState(null);
  const [estimatedSiteCost, setEstimatedSiteCost] = useState("");
  const [selectBroker, setSelectBroker] = useState("");
  const [brokerList, setBrokerList] = useState([]);
  const [formPercentageData, setFormPercentageData] = useState({
    percentage: "",
    percentage_of_bonus: "",
    percentage_of_bonus2: "",
    yearly_revenues: ""
  });

  const [stepFiles, setStepFiles] = useState({});
  const [selectedDocTypePerStep, setSelectedDocTypePerStep] = useState({});
  // Add these to your state declarations
  const [step2Questions, setStep2Questions] = useState([]);
  const [step2Answers, setStep2Answers] = useState({});
  const [calculatedPremium, setCalculatedPremium] = useState(0);
  const [manualTotalTaux, setManualTotalTaux] = useState("");
  const [manualTotalMontant, setManualTotalMontant] = useState("");
  const [manualTotalForfait, setManualTotalForfait] = useState("");

  const [guaranteeList, setGuaranteeList] = useState([]);
  const [guaranteeValues, setGuaranteeValues] = useState({});
  const [noDetail, setNoDetail] = useState(false);

  const totalDynamic = dynamicSteps.length;
  const totalSteps = 2 + totalDynamic + 1 + 2;

  const allowedFileTypes = [
    "application/msword",
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "application/pdf",
    "application/vnd.ms-excel",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "application/vnd.ms-powerpoint",
    "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  ];

  const maxFileSize = 50 * 1024 * 1024;

  const handleClose = () => {
    setShow(false);
    resetAll();
  };
  const handleShow = () => setShow(true);

  const resetAll = () => {
    setCurrentStep(1);
    setSelectedInsurer(null);
    setSelectedProduct(null);
    setDynamicSteps([]);
    setStepFiles({});
    setSelectedDocTypePerStep({});
    setFolderName("");
    setContractNo("");
    setSelectBroker("");
    setPolicyholderName("");
    setEstimatedStartDate(null);
    setEstimatedCompletionDate(null);
    setEstimatedSiteCost("");
    setFlashMessage({ type: "", message: "" });
    setStep2Answers({});
    setStep2Questions([]);
    setFormPercentageData({
      percentage: "",
      percentage_of_bonus: "",
      percentage_of_bonus2: "",
      yearly_revenues: ""
    });
    setCalculatedPremium(0);
    setManualTotalTaux("");
    setManualTotalMontant("");
    setManualTotalForfait("");
    setGuaranteeList([]);
    setGuaranteeValues({});
    setNoDetail(false);
  };

  useEffect(() => {
    if (userRole.includes("Gestionnaire ACS") && show) GetInsurersList();
  }, [show, userRole]);

  useEffect(() => {
    if (userRole.includes("Gestionnaire ACS") && show) {
      if (selectedInsurer?.value) ProductList(selectedInsurer?.value);
    } else {
      if (show) ProductList();
    }

  }, [show, selectedInsurer]);

  useEffect(() => {
    if (selectedProduct?.value) {
      buildDynamicSteps(selectedProduct.value);
    }
  }, [selectedProduct]);

  useEffect(() => {
    if (selectedProduct?.value && currentStep == 2) {
      GetQuestionsListWithoutLogicalBlock(selectedProduct?.value);
    }
  }, [currentStep, selectedProduct]);

  useEffect(() => {
    if (currentStep >= 3 && currentStep < 3 + totalDynamic) {
      const idx = currentStep - 3;
      const step = dynamicSteps[idx];
      if (step && !step.loaded) {
        loadDocumentTypesForStep(idx);
      }
    }
  }, [currentStep, dynamicSteps]);

  useEffect(() => {
    if (show) BrokerList();
  }, [show]);

  useEffect(() => {
    if (flashMessage.message) {
      const timer = setTimeout(() => setFlashMessage({ type: "", message: "" }), 3500);
      return () => clearTimeout(timer);
    }
  }, [flashMessage]);

  const GetInsurersList = async () => {
    setIsLoading(true);
    try {

      const response = await DashboardManagementService.insurer_list();

      if (response.data) {
        setIsLoading(false);
        const insurerList = response.data.insurerList || [];
        const insurerOptions = insurerList.map((data) => ({ value: data.id, label: data.first_name }));
        setInsurerOptions(insurerOptions);
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
    }
  };

  const ProductList = async (insurerId) => {
    setIsLoading(true);
    try {
      var userData = {
        ...(insurerId && { insurer_id: insurerId })
      };

      const response = await FilePageService.insurer_product_list(userData);

      if (response?.data?.status) {
        setIsLoading(false);
        const productList = response.data.insurerProductList || [];
        const productOptions = productList.map((data) => ({ value: data.id, label: data.name, risk_name: data.risk_name }));
        setProducOption(productOptions);
      }
    } catch (err) {
      setIsLoading(false);
      console.error(err);
    }
  };

  const buildDynamicSteps = async (productId) => {
    try {
      const res = await AddFolderPanelService.logical_block_by_product({ product_id: productId });
      if (res?.data?.status) {
        const blocks = res.data.LogicalBlocks || [];
        setGuaranteeList(res.data.guaranteeList || []);
        setNoDetail(res.data.guaranteeList?.length == 0 ? true : false);

        const steps = blocks.map((b, i) => ({
          stepNumber: i + 3,
          slug: b.slug,
          name: b.name || b.slug,
          documentTypes: [],
          loaded: false,
          questions: b.questions?.map(q => q.question) || [],
          answers: {},
        }));
        setDynamicSteps(steps);
      }
    } catch (err) {
      console.error(err);
      setFlashMessage({ type: "error", message: t("somethingWentWrong") });
    }
  };

  const BrokerList = async () => {
    try {
      const response = await AddFolderPanelService.broker_list();
      if (response?.data?.status) setBrokerList(response.data.brokerList || []);
    } catch (err) {
      console.error(err);
    }
  };

  const GetQuestionsListWithoutLogicalBlock = async (productId) => {
    try {
      const userData = { product_id: productId };
      const response = await AddFolderPanelService.questionsList_nologicalblock(userData);

      if (response?.data?.status) {
        setStep2Questions(response.data.questions || []);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleQuestionChange = (dynamicIndex, questionId, value) => {
    setDynamicSteps((prevSteps) => {
      const newSteps = [...prevSteps];
      const currentStep = { ...newSteps[dynamicIndex] };
      const newAnswers = { ...currentStep.answers };

      newAnswers[questionId] = value;

      const questionDef = currentStep.questions.find(q => q.id === questionId);

      if (questionDef?.sub_questions) {
        questionDef.sub_questions.forEach(subQ => {
          if (subQ.trigger_option !== value) {
            delete newAnswers[subQ.id];

            setStepFiles(prevFiles => {
              const updatedStepFiles = { ...prevFiles };
              if (updatedStepFiles[dynamicIndex]) {
                updatedStepFiles[dynamicIndex] = updatedStepFiles[dynamicIndex].filter(
                  f => f.question_id !== subQ.id
                );
              }
              return updatedStepFiles;
            });
          }
        });
      }

      currentStep.answers = newAnswers;
      newSteps[dynamicIndex] = currentStep;
      return newSteps;
    });
  };

  const renderQuestionsForStep = (dynamicIndex) => {
    const step = dynamicSteps[dynamicIndex];
    if (!step?.questions?.length) return null;

    const renderSingleQuestion = (q) => {
      switch (q.input_type) {
        case "text":
          return (
            <Form.Group key={q.id} className="mt-3">
              <Form.Label>{q.question_text}{q.is_required && <span> *</span>}</Form.Label>
              <Form.Control
                type="text"
                value={step.answers[q.id] || ""}
                onChange={(e) => handleQuestionChange(dynamicIndex, q.id, e.target.value)}
              />
            </Form.Group>
          );
        case "number":
          return (
            <Form.Group key={q.id} className="mt-3">
              <Form.Label>{q.question_text}{q.is_required && <span> *</span>}</Form.Label>
              <Form.Control
                type="number"
                value={step.answers[q.id] || ""}
                onChange={(e) => handleQuestionChange(dynamicIndex, q.id, e.target.value)}
                onWheel={(e) => e.target.blur()}
              />
            </Form.Group>
          );
        case "textarea":
          return (
            <Form.Group key={q.id} className="mt-3">
              <Form.Label>{q.question_text}{q.is_required && <span> *</span>}</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={step.answers[q.id] || ""}
                onChange={(e) => handleQuestionChange(dynamicIndex, q.id, e.target.value)}
              />
            </Form.Group>
          );
        case "file":
          return (
            <Form.Group key={q.id} className="mt-3">
              <Form.Label>{q.question_text}{q.is_required && <span> *</span>}</Form.Label>
              <div className="custom-upload-box" onDragOver={(e) => e.preventDefault()} onDrop={(e) => { e.preventDefault(); const files = e.dataTransfer.files; if (files.length) handleFileChangeForStep({ dataTransfer: { files } }, dynamicIndex, q.id); }}>
                <svg width="48" height="32" viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M38.7 12.08C37.34 5.18 31.28 0 24 0C18.22 0 13.2 3.28 10.7 8.08C4.68 8.72 0 13.82 0 20C0 26.62 5.38 32 12 32H38C43.52 32 48 27.52 48 22C48 16.72 43.9 12.44 38.7 12.08ZM38 28H12C7.58 28 4 24.42 4 20C4 15.9 7.06 12.48 11.12 12.06L13.26 11.84L14.26 9.94C16.16 6.28 19.88 4 24 4C29.24 4 33.76 7.72 34.78 12.86L35.38 15.86L38.44 16.08C41.56 16.28 44 18.9 44 22C44 25.3 41.3 28 38 28ZM16 18H21.1V24H26.9V18H32L24 10L16 18Z" fill="#00366B" />
                </svg>
                <p className="upload-text">{t("DragyourdocumentsLabel")} <span className="browse-link">{t("browsemyfilesLabel")}</span></p>
                <span>{t("documentsAcceptedLabel")} : mot, exceller, pdf, PowerPoint</span>
                <Form.Control type="file" className="file-input" onChange={(e) => handleFileChangeForStep(e, dynamicIndex, q.id)} />
              </div>
            </Form.Group>
          );
        case "select":
          {
            const selectedValue = step.answers[q.id] || "";

            const visibleSubQuestions = q.sub_questions?.filter(subQ => subQ.trigger_option === selectedValue) || [];

            return (
              <div key={q.id}>
                <Form.Group className="mt-3">
                  <Form.Label>{q.question_text}{q.is_required && <span> *</span>}</Form.Label>
                  <Form.Select
                    value={selectedValue}
                    onChange={(e) => handleQuestionChange(dynamicIndex, q.id, e.target.value)}
                  >
                    <option value="">Select</option>
                    {q.options?.map(opt => <option key={opt.id} value={opt.option_text}>{opt.option_text}</option>)}
                  </Form.Select>
                </Form.Group>

                {visibleSubQuestions?.map(subQ => renderSingleQuestion(subQ))}
              </div>
            );
          }
        default:
          return null;
      }
    };

    return step.questions.map((q) => renderSingleQuestion(q));
  };

  const areRequiredFieldsCompleted = (stepIndex) => {
    if (currentStep === 2) {
      return step2Questions.every((q) => {
        if (!q.is_required) return true;

        if (q.input_type === "file") {
          const filesForStep2 = stepFiles["step2"] || [];
          return filesForStep2.some(f => f.question_id === q.id);
        }

        const answer = step2Answers[q.id];
        return answer !== undefined && answer !== null && answer.toString().trim() !== "";
      });
    }

    const step = dynamicSteps[stepIndex];
    if (!step) return true;

    const questionsCompleted = step.questions?.every((q) => {
      if (!q.is_required) return true;

      switch (q.input_type) {
        case "file":
          const filesForStep = stepFiles[stepIndex] || [];
          return filesForStep.some(f => f.question_id === q.id || !f.question_id);
        default:
          const answer = step.answers[q.id];
          return answer && answer !== "";
      }
    }) ?? true;

    const filesCompleted = step.slug === "police"
      ? stepFiles[stepIndex] && stepFiles[stepIndex].length > 0
      : true;

    return questionsCompleted && filesCompleted;
  };

  const handleChange = (e) => {
    const { name, value, type } = e.target;

    if (type === "number") {
      if (value === "" || /^[0-9]*\.?[0-9]*$/.test(value)) {
        let num = Number(value);
        if (!isNaN(num) && name != "yearly_revenues") {
          if (num < 0) num = 0;
          if (num > 100) num = 100;
          setFormPercentageData((prev) => ({
            ...prev,
            [name]: num.toString(),
          }));
        } else {
          setFormPercentageData((prev) => ({
            ...prev,
            [name]: value,
          }));
        }
      }
    } else {
      setFormPercentageData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const loadDocumentTypesForStep = async (dynamicIndex) => {
    try {
      const step = dynamicSteps[dynamicIndex];
      if (!step) return;
      const res = await AddFolderPanelService.document_type_list(step.slug);
      if (res?.data?.status) {
        const docTypes = res.data.docTypeList || [];
        setDynamicSteps((prev) => {
          const copy = [...prev];
          copy[dynamicIndex] = { ...copy[dynamicIndex], documentTypes: docTypes, loaded: true };
          return copy;
        });
      } else {
        setFlashMessage({ type: "error", message: res?.data?.message || t("somethingWentWrong") });
      }
    } catch (err) {
      console.error(err);
      setFlashMessage({ type: "error", message: t("somethingWentWrong") });
    }
  };

  const handleFileChangeForStep = (e, dynamicIndex, questionId = null, overrideDocTypeId = null, overrideDocTypeName = null) => {
    const files = Array.from(e?.target?.files || e?.dataTransfer?.files || []);
    if (!files.length) return;

    const newFiles = [];
    for (const file of files) {
      if (!allowedFileTypes.includes(file.type)) {
        setFlashMessage({ type: "error", message: `Ce type de document n'est pas pris en charge: ${file.name}` });
        continue;
      }
      if (file.size > maxFileSize) {
        setFlashMessage({ type: "error", message: `Limite de taille atteinte. Vos fichiers ne doivent pas dépasser 50 Mo: ${file.name}` });
        continue;
      }

      const manuallySelectedDocType = selectedDocTypePerStep[dynamicIndex];
      if (manuallySelectedDocType) {
        overrideDocTypeId = manuallySelectedDocType.id;
        overrideDocTypeName = manuallySelectedDocType.name;
      }

      const step = dynamicSteps[dynamicIndex];
      const stepSlug = step?.slug;
      let defaultDocType = null;

      if (userRole.includes("Assureur") || userRole.includes("Gestionnaire ACS")) {
        if (stepSlug === "police") {
          defaultDocType = step?.documentTypes?.find((d) => d.name === "Police");
        } else {
          defaultDocType = step?.documentTypes?.find((d) => d.name === "Autres");
        }
      }

      const filterDocTypeBroker = step?.documentTypes?.find((d) => d.name === "Questionnaire");

      const docTypeId = overrideDocTypeId ?? (userRole.includes("Courtier") ? filterDocTypeBroker?.id : defaultDocType?.id);
      const docTypeName = overrideDocTypeName ?? (userRole.includes("Courtier") ? filterDocTypeBroker?.name : defaultDocType?.name);

      newFiles.push({
        file,
        filename: file.name,
        doc_type_id: docTypeId,
        doc_Type_Name: docTypeName,
        question_id: questionId,
      });
    }

    if (newFiles.length) {
      setStepFiles((prev) => ({
        ...prev,
        [dynamicIndex]: [...(prev[dynamicIndex] || []), ...newFiles]
      }));
    }

    if (e?.target) e.target.value = "";
  };

  const removeFileFromStep = (dynamicIndex, fileIndex) => {
    setStepFiles((prev) => {
      const copy = { ...prev };
      copy[dynamicIndex] = (copy[dynamicIndex] || []).filter((_, i) => i !== fileIndex);
      return copy;
    });
  };

  const getCombinedFiles = () => {
    const combined = [];
    for (let i = 0; i < totalDynamic; i++) {
      const files = stepFiles[i] || [];
      combined.push(...files);
    }
    return combined;
  };

  const HandleStoreDocument = async (e) => {
    e?.preventDefault?.();
    setUploadingDoc(true);
    try {
      const allFiles = getCombinedFiles();
      const generalDocuments = allFiles.filter(doc => !doc.question_id);

      if (!allFiles.length) {
        setFlashMessage({ type: "error", message: t("Veuillez ajouter au moins un document") });
        setUploadingDoc(false);
        return;
      }

      const formData = new FormData();

      // --- Basic Folder Information ---
      formData.append("folder_name", folderName ?? "");
      formData.append("insurer_id", selectedInsurer?.value ?? "");
      formData.append("product_id", selectedProduct?.value ?? "");
      formData.append("broker_id", userRole.includes("Courtier") ? userId : selectBroker);
      formData.append("contract_no", contractNo ?? "");
      formData.append("insurance_policyholder_name", policyholderName ?? "");
      formData.append("estimated_start_date", estimatedStartDate ?? "");
      formData.append("estimated_completion_date", estimatedCompletionDate ?? "");
      formData.append("estimated_site_cost", estimatedSiteCost ?? "");
      formData.append("percentage", formPercentageData.percentage == 0 ? "" : formPercentageData.percentage);
      formData.append("percentage_of_bonus", formPercentageData.percentage_of_bonus == 0 ? "" : formPercentageData.percentage_of_bonus);
      formData.append("percentage_of_bonus2", formPercentageData.percentage_of_bonus2 == 0 ? "" : formPercentageData.percentage_of_bonus2);
      formData.append("yearly_revenues", formPercentageData.yearly_revenues == 0 ? "" : formPercentageData.yearly_revenues);

      // --- Premium Details Calculation & Payload ---
      const premiumDetails = [];
      
      if (guaranteeList?.length > 0) {
        // Mapping values from the dynamic grid
        guaranteeList?.forEach((g) => {
          const values = guaranteeValues[g.guarantee_id] || {};
          premiumDetails?.push({
            guarantee_id: g.guarantee_basis_id,
            rate: values.taux || null,
            amount: values.montant || null,
            final_premium: values.forfait || null,
          });
        });
      } else {
        // Mapping values from manual entry (when list is empty)
        premiumDetails?.push({
          guarantee_id: null,
          rate: manualTotalTaux || null,
          amount: manualTotalMontant || null,
          final_premium: manualTotalForfait || null,
        });
      }

      // Append Premium Details to FormData
      premiumDetails?.forEach((item, index) => {
        formData.append(`premium_detail[${index}][guarantee_id]`, item.guarantee_id ?? "");
        formData.append(`premium_detail[${index}][rate]`, item.rate ?? "");
        formData.append(`premium_detail[${index}][amount]`, item.amount ?? "");
        formData.append(`premium_detail[${index}][final_premium]`, item.final_premium ?? "");
      });

      // --- Step 2 (General) Questions ---
      step2Questions.forEach((q, qIndex) => {
        const fileEntry = stepFiles["step2"]?.find(f => f.question_id === q.id);
        const file = fileEntry?.file ?? null;

        const basePath = `general_answers[0][questions][${qIndex}]`;

        formData.append(`${basePath}[question_id]`, q.id);
        formData.append(`${basePath}[question_text]`, q.question_text);
        formData.append(`${basePath}[input_type]`, q.input_type);

        const currentAnswer = step2Answers[q.id] || (fileEntry ? fileEntry.filename : "");
        formData.append(`${basePath}[answer]`, currentAnswer);

        if (file) formData.append(`${basePath}[file]`, file);

        if (q.sub_questions && q.sub_questions.length > 0) {
          q.sub_questions.forEach((subQ, subIndex) => {
            const subPath = `${basePath}[sub_answers][${subIndex}]`;

            formData.append(`${subPath}[question_id]`, subQ.id);
            formData.append(`${subPath}[question_text]`, subQ.question_text);
            formData.append(`${subPath}[input_type]`, subQ.input_type);

            formData.append(`${subPath}[answer]`, step2Answers[subQ.id] ?? "");
          });
        }
      });

      formData.append(`general_answers[0][step_slug]`, "general_information");

      // --- Dynamic Steps Questions ---
      dynamicSteps.forEach((step, stepIndex) => {
        step.questions.forEach((q, qIndex) => {
          const basePath = `answers[${stepIndex}][questions][${qIndex}]`;

          formData.append(`${basePath}[question_id]`, q.id);
          formData.append(`${basePath}[question_text]`, q.question_text || q.text);
          formData.append(`${basePath}[input_type]`, q.input_type);

          const fileObj = stepFiles[stepIndex]?.find(f => f.question_id === q.id);
          const parentAnswer = q.input_type === "file" ? (fileObj?.filename || "") : (step.answers[q.id] ?? "");
          formData.append(`${basePath}[answer]`, parentAnswer);


          if (q.input_type === "file" && fileObj?.file) {
            formData.append(`${basePath}[file]`, fileObj.file);
          }

          const activeSubQuestions = q.sub_questions?.filter(subQ => subQ.trigger_option === parentAnswer) || [];

          activeSubQuestions.forEach((subQ, subIndex) => {
            const subPath = `${basePath}[sub_answers][${subIndex}]`;
            const subFileObj = stepFiles[stepIndex]?.find(f => f.question_id === subQ.id);

            formData.append(`${subPath}[question_id]`, subQ.id);
            formData.append(`${subPath}[question_text]`, subQ.question_text);
            formData.append(`${subPath}[input_type]`, subQ.input_type);

            const subAnswer = subQ.input_type === "file" ? (subFileObj?.filename || "") : (step.answers[subQ.id] ?? "");
            formData.append(`${subPath}[answer]`, subAnswer);

            if (subFileObj?.file) {
              formData.append(`${subPath}[file]`, subFileObj.file);
            }
          });
        });

        formData.append(`answers[${stepIndex}][step_slug]`, step.slug);
      });

      // --- General Documents ---
      generalDocuments.forEach((doc, index) => {
        formData.append(`documents[${index}][file]`, doc.file);
        formData.append(`documents[${index}][filename]`, doc.filename);
        formData.append(`documents[${index}][doc_type_id]`, doc.doc_type_id);
        formData.append(`documents[${index}][doc_Type_Name]`, doc.doc_Type_Name);
      });

      // --- API Service Call ---
      const response = await AddFolderPanelService.store_document(formData, { headers: { "Content-Type": "multipart/form-data" } });

      if (response?.data?.status) {
        setCurrentStep(totalSteps);
        if ((userRole.includes("Courtier") || userRole.includes("Assureur")) && file) {
          FolderList(search, sort, currentPage, editUserStatus);
        } else {
          GetStatistics();
          GetTaskStatistics();
          GetAptAtotFromTransferHistory();
        }
      } else {
        setFlashMessage({ type: "error", message: response?.data?.message || t("somethingWentWrong") });
      }
    } catch (error) {
      if (error.response?.data?.message === "La valeur du champ folder name a déjà été prise.") {
        setFlashMessage({ type: "error", message: error.response.data.message });
        setCurrentStep(2);
      } else {
        setFlashMessage({ type: "error", message: t("somethingWentWrong") });
      }
    } finally {
      setUploadingDoc(false);
    }
  };

  const HandlePreviousPage = () => {
    setSelectedDocTypePerStep({});
    if (currentStep > 1) setCurrentStep((prev) => prev - 1);
  };

  const handleNextPage = () => {
    setSelectedDocTypePerStep({});
    if (currentStep === 1) {
      if (!selectedProduct) {
        setFlashMessage({ type: "error", message: t("Please select a product") });
        return;
      }
    }

    if (currentStep === 2) {
      if (!folderName) {
        setFlashMessage({ type: "error", message: t("Please provide a folder name") });
        return;
      }
      const result = calculatePremiumPrice();
      setCalculatedPremium(result);
    }

    const dynamicIndex = currentStep - 3;
    if (currentStep >= 3 && currentStep < 3 + totalDynamic) {
      const step = dynamicSteps[dynamicIndex];
      if (step?.slug === "police" && userRole.includes("Courtier") && !selectedDocTypePerStep[dynamicIndex]?.id) {
        setFlashMessage({ type: "error", message: t("Veuillez sélectionner un type de document") });
        return;
      }
    }


    if (currentStep < totalSteps) setCurrentStep((prev) => prev + 1);
  };

  const handleBrokerChange = (e) => setSelectBroker(e.target.value);

  const formatDate = (dateString) => {
    if (!dateString) return "";
    if (typeof dateString === "string") return dateString;
    const date = dateString instanceof Date ? dateString : new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const getFormattedDate = (dateString) => {
    if (!dateString) return null;
    const [day, month, year] = dateString.split("/");
    return new Date(`${month}/${day}/${year}`);
  };

  const handleStep2QuestionChange = (questionId, value) => {
    setStep2Answers((prev) => ({
      ...prev,
      [questionId]: value,
    }));
  };

  const renderStep2Questions = () => {
    if (!step2Questions.length) return null;


    const renderSingleQuestion = (q) => {
      switch (q.input_type) {
        case "text":
          return (
            <Form.Group key={q.id} className="mt-32">
              <Form.Label>{q.question_text}{q.is_required && <span> *</span>}</Form.Label>
              <Form.Control
                type="text"
                value={step2Answers[q.id] || ""}
                onChange={(e) => handleStep2QuestionChange(q.id, e.target.value)}
              />
            </Form.Group>
          );
        case "number":
          return (
            <Form.Group key={q.id} className="mt-32">
              <Form.Label>{q.question_text}{q.is_required && <span> *</span>}</Form.Label>
              <Form.Control
                type="text"
                value={step2Answers[q.id] || ""}
                onChange={(e) => handleStep2QuestionChange(q.id, e.target.value)}
              />
            </Form.Group>
          );
        case "textarea":
          return (
            <Form.Group key={q.id} className="mt-3">
              <Form.Label>{q.question_text}{q.is_required && <span> *</span>}</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                value={step2Answers[q.id] || ""}
                onChange={(e) => handleStep2QuestionChange(q.id, e.target.value)}
              />
            </Form.Group>
          );
        case "file":
          const filesForThisQuestion = (stepFiles["step2"] || []).filter(
            (f) => f.question_id === q.id
          );

          return (
            <Form.Group key={q.id} className="mt-3">
              <Form.Label>
                {q.question_text}
                {q.is_required && <span> *</span>}
              </Form.Label>

              <div
                className="custom-upload-box"
                onDragOver={(e) => e.preventDefault()}
                onDrop={(e) => {
                  e.preventDefault();
                  const files = e.dataTransfer.files;
                  if (files.length) {
                    handleFileChangeForStep({ dataTransfer: { files } }, "step2", q.id);
                  }
                }}
              >
                <svg width="48" height="32" viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M38.7 12.08C37.34 5.18 31.28 0 24 0C18.22 0 13.2 3.28 10.7 8.08C4.68 8.72 0 13.82 0 20C0 26.62 5.38 32 12 32H38C43.52 32 48 27.52 48 22C48 16.72 43.9 12.44 38.7 12.08ZM38 28H12C7.58 28 4 24.42 4 20C4 15.9 7.06 12.48 11.12 12.06L13.26 11.84L14.26 9.94C16.16 6.28 19.88 4 24 4C29.24 4 33.76 7.72 34.78 12.86L35.38 15.86L38.44 16.08C41.56 16.28 44 18.9 44 22C44 25.3 41.3 28 38 28ZM16 18H21.1V24H26.9V18H32L24 10L16 18Z" fill="#00366B" />
                </svg>
                <p className="upload-text">
                  {t("DragyourdocumentsLabel")}{" "}
                  <span className="browse-link">{t("browsemyfilesLabel")}</span>
                </p>
                <span>{t("documentsAcceptedLabel")} : mot, exceller, pdf, PowerPoint</span>
                <Form.Control
                  type="file"
                  className="file-input"
                  onChange={(e) => handleFileChangeForStep(e, "step2", q.id)}
                />
              </div>

              {filesForThisQuestion.length > 0 && (
                <div className="upload-file-list">
                  {filesForThisQuestion.map((f, idx) => (
                    <div key={idx} className="upload-file">
                      <span>{f.filename}</span>
                      <div className="d-flex align-items-center gap-3">
                        <a
                          onClick={() => {
                            setStepFiles((prev) => ({
                              ...prev,
                              step2: prev.step2.filter((file) => file !== f),
                            }));
                          }}
                          className="remove-file-link"
                        >
                          <svg width="14" height="18" viewBox="0 0 14 18" fill="none">
                            <path d="M11 6V16H3V6H11ZM9.5 0H4.5L3.5 1H0V3H14V1H10.5L9.5 0ZM13 4H1V16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4Z" fill="#e84455" />
                          </svg>
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </Form.Group>
          );
        case "select":
          {
            const selectedValue = step2Answers[q.id] || "";

            const visibleSubQuestions = q.sub_questions?.filter(subQ => subQ.trigger_option === selectedValue) || [];

            return (
              <div key={q.id}>
                <Form.Group className="mt-3">
                  <Form.Label>{q.question_text}{q.is_required && <span> *</span>}</Form.Label>
                  <Form.Select
                    value={selectedValue}
                    onChange={(e) => handleStep2QuestionChange(q.id, e.target.value)}
                  >
                    <option value="">Select</option>
                    {q.options?.map(opt => <option key={opt.id} value={opt.option_text}>{opt.option_text}</option>)}
                  </Form.Select>
                </Form.Group>

                {visibleSubQuestions.map(subQ => renderSingleQuestion(subQ))}
              </div>
            );
          };
        default:
          return null;
      }
    };

    return step2Questions.map((q) => renderSingleQuestion(q));
  };

  const renderProductStep = () => (
    isLoading ? <Loading /> :
      <div className="step-1">
        {(userRole.includes("Gestionnaire ACS") || selectedInsurer?.value) ?
          <h2>1 - Sélectionnez un assureur et un produit</h2>
          :
          <h2>1 - Sélectionnez un produit</h2>
        }
        <Form>
          {flashMessage.message && (
            <div className={`mt-3 alert ${flashMessage.type === "success" ? "alert-success" : "alert-danger"} text-center`} role="alert">
              {flashMessage.message}
            </div>
          )}

          {userRole.includes("Gestionnaire ACS") && (
            <Form.Group className="mt-32" controlId="formProduct">
              <Form.Label>
                Assureur <span>*</span>
              </Form.Label>
              <Select
                options={insurerOptions}
                value={selectedInsurer}
                onChange={(selectedOption) => {
                  setSelectedInsurer(selectedOption);
                  setSelectedProduct(null);
                }}
                placeholder={"Sélectionner Assureur"}
                isSearchable={true}
                noOptionsMessage={() => t("NorecordsfoundLabel")}
              />
            </Form.Group>
          )}

          {(!userRole.includes("Gestionnaire ACS") || (userRole.includes("Gestionnaire ACS") && selectedInsurer?.value)) && (
            <Form.Group className="mt-32" controlId="formProduct">
              <Form.Label>
                Produits <span>*</span>
              </Form.Label>
              <Select
                options={productOption}
                value={selectedProduct}
                onChange={(selectedOption) => {
                  setSelectedProduct(selectedOption);
                  setManualTotalTaux("");
                  setManualTotalMontant("");
                  setManualTotalForfait("");
                  setGuaranteeValues({});
                  setNoDetail(false);
                }}
                placeholder={"Sélectionnez le type de risque"}
                isSearchable={true}
                noOptionsMessage={() => t("NorecordsfoundLabel")}
              />
            </Form.Group>
          )}
        </Form>
      </div>
  );

  const renderFolderInfoStep = () => (
    <div className="step-2">
      <h2>2 - Information dossiers</h2>
      <span className="complete-process">Complétez les informations relatives au dossier</span>
      <Form>
        {flashMessage.message && (
          <div className={`mt-3 alert ${flashMessage.type === "success" ? "alert-success" : "alert-danger"} text-center`} role="alert">
            {flashMessage.message}
          </div>
        )}

        <Form.Group className="mt-32" controlId="folderName">
          <Form.Label>
            N° de dossier <span>*</span>
          </Form.Label>
          <Form.Control
            type="text"
            placeholder="N° de dossier"
            value={folderName}
            onChange={(e) => setFolderName(e.target.value)}
          />
        </Form.Group>

        {renderStep2Questions()}

        <Form.Group className="mt-32" controlId="contractNo">
          <Form.Label>Numéro de contrat</Form.Label>
          <Form.Control type="text" placeholder="Numéro de contrat" value={contractNo} onChange={(e) => setContractNo(e.target.value)} />
        </Form.Group>

        <Form.Group className="mt-32" controlId="policyholderName">
          <Form.Label>Nom du preneur d'assurance</Form.Label>
          <Form.Control type="text" placeholder="Nom du preneur d'assurance" value={policyholderName} onChange={(e) => setPolicyholderName(e.target.value)} />
        </Form.Group>

        <Form.Group className="mt-32" controlId="estimatedStartDate">
          <Form.Label className="d-block">Date de début prévisionnelle</Form.Label>
          <DatePicker placeholderText="Selectionner une date de début prévisionnelle" selected={getFormattedDate(estimatedStartDate)} onChange={(date) => setEstimatedStartDate(formatDate(date))} dateFormat="dd/MM/yyyy" locale={fr} />
        </Form.Group>

        <Form.Group className="mt-32" controlId="estimatedCompletionDate">
          <Form.Label className="d-block">Date de fin de chantier prévisionnelle</Form.Label>
          <DatePicker placeholderText="Selectionner une date de fin de chantier prévisionnelle" selected={getFormattedDate(estimatedCompletionDate)} onChange={(date) => setEstimatedCompletionDate(formatDate(date))} dateFormat="dd/MM/yyyy" locale={fr} />
        </Form.Group>

        <Form.Group className="mt-32" controlId="estimatedSiteCost">
          <Form.Label>Coût prévisionnel du chantier</Form.Label>
          <Form.Control
            type="text"
            placeholder="Entrez le coût estimé du site"
            value={estimatedSiteCost}
            onChange={(e) => {
              const val = e.target.value.replace(/[^0-9.]/g, "");
              setEstimatedSiteCost(val);
            }}
          />
        </Form.Group>

        <Form.Group className="mt-32" controlId="estimatedSiteCost">
          <Form.Label>Taux de base</Form.Label>
          <Form.Control
            type="number"
            name="percentage"
            value={formPercentageData.percentage}
            onChange={handleChange}
            placeholder="Taux de base"
            min={0}
            max={100}
            onWheel={(e) => e.target.blur()}
          />
        </Form.Group>

        <Form.Group className="mt-32" controlId="estimatedSiteCost">
          <Form.Label>Pourcentage de bonus commercial</Form.Label>
          <Form.Control
            type="number"
            name="percentage_of_bonus2"
            value={formPercentageData.percentage_of_bonus2}
            onChange={handleChange}
            placeholder="Pourcentage de bonus commercial"
            min={0}
            max={100}
            onWheel={(e) => e.target.blur()}
          />
        </Form.Group>

        <Form.Group className="mt-32" controlId="estimatedSiteCost">
          <Form.Label>Revenu annuel</Form.Label>
          <Form.Control
            type="number"
            name="yearly_revenues"
            value={formPercentageData.yearly_revenues}
            onChange={handleChange}
            placeholder="Revenu annuel"
            min={0}
            onWheel={(e) => e.target.blur()}
          />
        </Form.Group>

        <Form.Group className="mt-32" controlId="estimatedSiteCost">
          <Form.Label>Taux de minoration</Form.Label>
          <Form.Control
            type="number"
            name="percentage_of_bonus"
            value={formPercentageData.percentage_of_bonus}
            onChange={handleChange}
            placeholder="Taux de minoration"
            min={0}
            max={100}
            onWheel={(e) => e.target.blur()}
          />
        </Form.Group>

        {!userRole.includes("Courtier") && (
          <Form.Group className="mt-32" controlId="selectBroker">
            <Form.Label>Sélectionner Courtier</Form.Label>
            <Form.Select className="full-width mb-3" aria-label={"statusSelectAria"} value={selectBroker} onChange={handleBrokerChange}>
              <option value="" disabled>
                Sélectionner Courtier
              </option>
              {brokerList?.length > 0 ? brokerList.map((broker) => <option value={broker.id}>{broker.first_name}</option>) : <option value="">{t("NorecordsfoundLabel")}</option>}
            </Form.Select>
            <AddBroker BrokerList={BrokerList} />
          </Form.Group>
        )}
      </Form>
    </div>
  );

  const calculatePremiumPrice = () => {
    const EstimatedSiteCost = parseFloat(estimatedSiteCost) || 0;
    const yearlyRevenues = parseFloat(formPercentageData.yearly_revenues) || 0;
    const percentage = parseFloat(formPercentageData.percentage) || 0;
    const bonus1 = parseFloat(formPercentageData.percentage_of_bonus) || 0;
    const bonus2 = parseFloat(formPercentageData.percentage_of_bonus2) || 0;

    let baseAmount = 0;
    const riskType = selectedProduct?.risk_name;

    if (riskType?.includes("DO")) {
      baseAmount = EstimatedSiteCost;
    } else if (riskType?.includes("RCD")) {
      baseAmount = yearlyRevenues;
    }

    const total = (baseAmount * (percentage / 100)) + bonus1 + bonus2;

    return total.toFixed(2);
  };

  const renderDynamicStep = (dynamicIndex) => {
    const step = dynamicSteps[dynamicIndex];
    const files = stepFiles[dynamicIndex] || [];
    const docTypes = step?.documentTypes || [];

    const handleDocTypeChange = (e) => {
      setSelectedDocTypePerStep((prev) => ({
        ...prev,
        [dynamicIndex]: docTypes.find(dt => dt.id === parseInt(e.target.value)),
      }));
    };

    return (
      <div key={dynamicIndex} className={`step-dynamic step-${dynamicIndex + 3}`}>
        <h2>{`${dynamicIndex + 3} - ${step?.name || 'Document'}`} {userRole.includes("Courtier") ? <span>*</span> : (userRole.includes("Assureur") && step?.slug === "police") ? <span>*</span> : null}</h2>
        <span className="complete-process">Ajouter d'autres documents liés au dossier</span>

        <Form>
          {flashMessage.message && (
            <div className={`mt-3 alert ${flashMessage.type === "success" ? "alert-success" : "alert-danger"} text-center`} role="alert">
              {flashMessage.message}
            </div>
          )}

          {renderQuestionsForStep(dynamicIndex)}

          {step?.slug !== "police" && docTypes.length > 0 && (
            <Form.Group className="mt-32" controlId={`formDocType-${dynamicIndex}`}>
              <Form.Label>{t("documentTypeLabel")}</Form.Label>
              <Form.Select
                aria-label="Choisir un type de document"
                value={selectedDocTypePerStep[dynamicIndex]?.id || ""}
                onChange={handleDocTypeChange}
              >
                <option value="">{t("selectDocumentTypeLabel")}</option>
                {docTypes.map((doctype) => (
                  <option key={doctype.id} value={doctype.id}>
                    {doctype.name}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>
          )}

          <Form.Group controlId={`formFileDynamic-${dynamicIndex}`} className="file-upload-container mt-4">
            <div className="custom-upload-box" onDragOver={(e) => e.preventDefault()} onDrop={(e) => { e.preventDefault(); const files = e.dataTransfer.files; if (files.length) handleFileChangeForStep({ dataTransfer: { files } }, dynamicIndex); }}>
              <svg width="48" height="32" viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M38.7 12.08C37.34 5.18 31.28 0 24 0C18.22 0 13.2 3.28 10.7 8.08C4.68 8.72 0 13.82 0 20C0 26.62 5.38 32 12 32H38C43.52 32 48 27.52 48 22C48 16.72 43.9 12.44 38.7 12.08ZM38 28H12C7.58 28 4 24.42 4 20C4 15.9 7.06 12.48 11.12 12.06L13.26 11.84L14.26 9.94C16.16 6.28 19.88 4 24 4C29.24 4 33.76 7.72 34.78 12.86L35.38 15.86L38.44 16.08C41.56 16.28 44 18.9 44 22C44 25.3 41.3 28 38 28ZM16 18H21.1V24H26.9V18H32L24 10L16 18Z" fill="#00366B" />
              </svg>
              <p className="upload-text">{t("DragyourdocumentsLabel")} <span className="browse-link">{t("browsemyfilesLabel")}</span></p>
              <span>{t("documentsAcceptedLabel")} : mot, exceller, pdf, PowerPoint</span>
              <Form.Control type="file" className="file-input" multiple onChange={(e) => handleFileChangeForStep(e, dynamicIndex)} />
            </div>
          </Form.Group>
        </Form>

        {files.length > 0 && (
          <div className="upload-file-list">
            {files.map((file, idx) => (
              <div key={idx} className="upload-file">
                <span>{file.filename}</span>
                <div className="d-flex align-items-center gap-3">
                  <a onClick={() => removeFileFromStep(dynamicIndex, idx)} className="remove-file-link">
                    <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 6V16H3V6H11ZM9.5 0H4.5L3.5 1H0V3H14V1H10.5L9.5 0ZM13 4H1V16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4Z" fill="#e84455" /></svg>
                  </a>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const handleGuaranteeChange = (id, field, value) => {
    var base = parseFloat(calculatedPremium) || 0;
    var numValue = parseFloat(value) || 0;

    setGuaranteeValues(prev => {
      const currentGuarantee = { ...prev[id] };

      if (field === "taux") {
        if (numValue < 0) numValue = 0;
        if (numValue > 100) numValue = 100;

        currentGuarantee.taux = numValue.toString();
        if (base > 0) {
          currentGuarantee.montant = ((base * numValue) / 100).toFixed(2);
        }
      } else if (field === "montant") {
        if (base > 0 && numValue > base) {
          numValue = base;
          value = base.toString();
        }

        currentGuarantee.montant = value;
        if (base > 0) {
          currentGuarantee.taux = ((numValue / base) * 100).toFixed(2);
        }
      } else if (field === "forfait") {
        currentGuarantee.forfait = value;
      }

      return {
        ...prev,
        [id]: currentGuarantee
      };
    });
  };

  const totalTaux = Object.values(guaranteeValues).reduce((acc, curr) => {
    return acc + (parseFloat(curr.taux) || 0);
  }, 0);

  const totalMontant = Object.values(guaranteeValues).reduce((acc, curr) => {
    return acc + (parseFloat(curr.montant) || 0);
  }, 0);

  const totalForfait = Object.values(guaranteeValues).reduce((acc, curr) => {
    return acc + (parseFloat(curr.forfait) || 0);
  }, 0);

  const isFieldDisabled = noDetail || (guaranteeList?.length === 0);

  const renderGuaranteeStep = () => (
    <div className="guarantee-step">
      <h2>{3 + totalDynamic} - Détail des Garanties</h2>
      {/* No Detail Checkbox Section */}
      {guaranteeList?.length == 0 &&
        <div className="d-flex align-items-center mt-3 mb-4 gap-2">
          <label htmlFor="no-detail-checkbox" className="d-flex align-items-center gap-2" style={{ cursor: "pointer" }}>
            <Form.Check
              type="checkbox"
              id="no-detail-checkbox"
              // disabled={noDetail}
              checked={noDetail}
              onChange={(e) => setNoDetail(e.target.checked)}
            />
            <div className="no-detail-box mb-2">
              {t("NorecordsfoundLabel")}
            </div>
          </label>
        </div>
      }

      <div className="premium-display-container">
        <span className="premium-label">Montant de la prime calculé:</span>
        <span className="premium-value">{calculatedPremium} €</span>
      </div>

      <div className={`guarantee-grid mt-0`}>
        {/* Header Row */}
        <div className={`${noDetail ? "opacity-50 pointer-events-none" : ""}`}>
          <div className="row mb-3 font-weight-bold text-center">
            <div className="col-3 text-start">{t("Guarantee")}</div>
            <div className="col-4 text-center">%</div>
            <div className="col-5 text-center">{t("Forfait")}</div>
          </div>

          <hr />

          {/* Dynamic Guarantee Rows */}
          {guaranteeList?.length > 0 ? (
            guaranteeList?.map((data, index) => (
              <div key={index} className="row mb-3 align-items-center text-center">
                <div className="col-3 text-start">{data.guarantee_name}</div>
                <div className="col-2">
                  <Form.Control
                    type="number"
                    placeholder="Taux"
                    disabled={noDetail}
                    value={guaranteeValues[data.guarantee_basis_id]?.taux || ""}
                    onChange={(e) => handleGuaranteeChange(data.guarantee_basis_id, "taux", e.target.value)}
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
                <div className="col-1">+</div>
                <div className="col-2">
                  <Form.Control
                    type="number"
                    placeholder="€"
                    disabled={noDetail}
                    value={guaranteeValues[data.guarantee_basis_id]?.montant || ""}
                    onChange={(e) => handleGuaranteeChange(data.guarantee_basis_id, "montant", e.target.value)}
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
                <div className="col-1 text-muted">OU</div>
                <div className="col-3">
                  <Form.Control
                    type="number"
                    placeholder="Forfait €"
                    disabled={noDetail}
                    value={guaranteeValues[data.guarantee_basis_id]?.forfait || ""}
                    onChange={(e) => handleGuaranteeChange(data.guarantee_basis_id, "forfait", e.target.value)}
                    onWheel={(e) => e.target.blur()}
                  />
                </div>
              </div>
            )
            )) : (
            <div className="text-center mt-4 no-records">
              <p>{t("NorecordsfoundLabel")}</p>
            </div>
          )}
        </div>

        <hr className="mt-4" style={{ borderTop: "2px solid #000" }} />

        {/* Prime Totale Summary Row */}
        <div className="row mt-3 align-items-center text-center font-weight-bold">
          <div className="col-3 text-start">Prime totale</div>

          <div className="col-2">
            <Form.Control
              type="text"
              placeholder="Taux %"
              disabled={guaranteeList?.length > 0}
              readOnly={guaranteeList?.length > 0}
              value={guaranteeList?.length > 0 ? `${totalTaux}%` : manualTotalTaux}
              onChange={(e) => {
                if (guaranteeList?.length === 0) {
                  let val = e.target.value.replace(/[^0-9.]/g, "");
                  let numValue = parseFloat(val) || 0;
                  const base = parseFloat(calculatedPremium) || 0;

                  if (numValue < 0) numValue = 0;
                  if (numValue > 100) numValue = 100;
                  val = numValue.toString();

                  setManualTotalTaux(val);
                  if (base > 0) {
                    setManualTotalMontant(((base * numValue) / 100).toFixed(2));
                  }
                }
              }}
              className={`text-center font-weight-bold custom-disabled-input ${isFieldDisabled ? "disabled-style" : ""}`}
            />
          </div>

          <div className="col-1">+</div>

          <div className="col-2">
            <Form.Control
              type="text"
              placeholder="€"
              disabled={guaranteeList?.length > 0}
              readOnly={guaranteeList?.length > 0}
              value={guaranteeList?.length > 0 ? `${totalMontant} €` : manualTotalMontant}
              onChange={(e) => {
                if (guaranteeList?.length === 0) {
                  let val = e.target.value.replace(/[^0-9.]/g, "");
                  let numValue = parseFloat(val) || 0;
                  const base = parseFloat(calculatedPremium) || 0;

                  if (base > 0 && numValue > base) {
                    numValue = base;
                    val = base.toString();
                  }

                  setManualTotalMontant(val);
                  if (base > 0) {
                    setManualTotalTaux(((numValue / base) * 100).toFixed(2));
                  }
                }
              }}
              className={`text-center font-weight-bold custom-disabled-input ${isFieldDisabled ? "disabled-style" : ""}`}
            />
          </div>

          <div className="col-1">OU</div>

          <div className="col-3">
            <Form.Control
              type="text"
              placeholder="Forfait €"
              disabled={guaranteeList?.length > 0}
              readOnly={guaranteeList?.length > 0}
              value={guaranteeList?.length > 0 ? (totalForfait > 0 ? `${totalForfait} €` : "") : manualTotalForfait}
              onChange={(e) => {
                if (guaranteeList?.length === 0) {
                  setManualTotalForfait(e.target.value.replace(/[^0-9.]/g, ""));
                }
              }}
              className={`text-center font-weight-bold custom-disabled-input ${isFieldDisabled ? "disabled-style" : ""}`}
            />
          </div>
        </div>
      </div>
    </div>
  );

  const renderSummary = () => {
    const combined = getCombinedFiles();
    return (
      <div>
        <h2>{`${4 + totalDynamic} - Récapitulatif`}</h2>
        <Form>
          {flashMessage.message && (
            <div className={`mt-3 alert ${flashMessage.type === "success" ? "alert-success" : "alert-danger"} text-center`} role="alert">
              {flashMessage.message}
            </div>
          )}

          <Form.Group className="mt-32" controlId="summaryInfo">
            <Form.Label>Informations générales</Form.Label>
          </Form.Group>

          <div className="d-flex justify-content-between align-aitems-center mt-24">
            <div className="file-name">N° Dossier</div>
            <div className="file-number">{folderName}</div>
          </div>

          <div className="d-flex justify-content-between align-aitems-center mt-24">
            <div className="file-name">Produit</div>
            <div className="file-number">{selectedProduct?.label}</div>
          </div>

          {userRole.includes("Courtier") && (
            <div className="d-flex justify-content-between align-aitems-center mt-24">
              <div className="file-name">Courtier</div>
              <div className="file-number">{userName}</div>
            </div>
          )}

          <Form.Group className="mt-32" controlId="documentsAssociated">
            <Form.Label>Documents associés</Form.Label>
          </Form.Group>

          {combined.length > 0 && (
            <div className="upload-file-list">
              {combined.map((file, index) => (
                <div key={index} className="upload-file">
                  <span className="filename">{file.filename}</span>
                  <div className="d-flex align-items-center gap-3">
                    <span className="certificate-name">{file.doc_Type_Name}</span>
                    <a onClick={() => {
                      let left = index;
                      for (let i = 0; i < totalDynamic; i++) {
                        const arr = stepFiles[i] || [];
                        if (left < arr.length) { removeFileFromStep(i, left); break; }
                        left -= arr.length;
                      }
                    }}>
                      <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 6V16H3V6H11ZM9.5 0H4.5L3.5 1H0V3H14V1H10.5L9.5 0ZM13 4H1V16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4Z" fill="#e84455" /></svg>
                    </a>
                  </div>
                </div>
              ))}
            </div>
          )}
        </Form>
      </div>
    );
  };

  const renderFinal = () => (
    <div>
      <div className="final-submit">
        <svg width="140" height="94" viewBox="0 0 140 94" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M112.875 35.5668C108.908 15.4418 91.2333 0.333496 70 0.333496C53.1417 0.333496 38.5 9.90016 31.2083 23.9002C13.65 25.7668 0 40.6418 0 58.6668C0 77.9752 15.6917 93.6668 35 93.6668H110.833C126.933 93.6668 140 80.6002 140 64.5002C140 49.1002 128.042 36.6168 112.875 35.5668ZM110.833 82.0002H35C22.1083 82.0002 11.6667 71.5585 11.6667 58.6668C11.6667 46.7085 20.5917 36.7335 32.4333 35.5085L38.675 34.8668L41.5917 29.3252C47.1333 18.6502 57.9833 12.0002 70 12.0002C85.2833 12.0002 98.4667 22.8502 101.442 37.8418L103.192 46.5918L112.117 47.2335C121.217 47.8168 128.333 55.4585 128.333 64.5002C128.333 74.1252 120.458 82.0002 110.833 82.0002ZM58.3333 59.7168L46.1417 47.5252L37.9167 55.7502L58.3333 76.1668L93.3917 41.1085L85.1667 32.8835L58.3333 59.7168Z" fill="#00366B" />
        </svg>
        <h2>Le dossier a été créé</h2>
        {userRole.includes("Courtier") && <span className="complete-process">Notre équipe de souscription reviendra vers vous sous 48 heures</span>}
        <a onClick={handleClose} className="close-sutter">Fermer le volet</a>
      </div>
    </div>
  );

  return (
    <Fragment>
      <style>{` button.btn.btn-primary  { background-color: ${localStorage.getItem('button_color') ? JSON.parse(localStorage.getItem('button_color')) : "#e84455"} !Important};`}</style>

      <button onClick={handleShow} className="btn-secondary btn btn-primary">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="white" /></svg>
        Ajouter un dossier
      </button>

      <Offcanvas className={`add-folder-panel ${data ? data : ""}`} placement={"end"} show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Nouveau dossier</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          {currentStep === 1 && renderProductStep()}
          {currentStep === 2 && renderFolderInfoStep()}
          {currentStep >= 3 && currentStep < 3 + totalDynamic && renderDynamicStep(currentStep - 3)}
          {currentStep === 3 + totalDynamic && renderGuaranteeStep()}
          {currentStep === 4 + totalDynamic && renderSummary()}
          {currentStep === 5 + totalDynamic && renderFinal()}
        </Offcanvas.Body>

        <div className="offcanvas-footer text-end">
          {currentStep !== 1 &&
            <button
              type="button"
              className="btn btn-primary float-left previous-btn"
              onClick={HandlePreviousPage}
            >
              <svg height="9px" width="12px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 410.258 410.258"><polygon fill="#ffffffff" points="298.052,24 266.052,0 112.206,205.129 266.052,410.258 298.052,386.258 162.206,205.129" /></svg>
              {t("previousButton")}
            </button>
          }

          <button
            type="button"
            className="btn btn-primary"
            disabled={
              (currentStep === 1 && !selectedProduct) ||
              (currentStep === 2 && (!folderName || !areRequiredFieldsCompleted())) ||
              (currentStep >= 3 && currentStep < 3 + totalDynamic && !areRequiredFieldsCompleted(currentStep - 3))
            }
            onClick={(e) => {
              if (currentStep === 4 + totalDynamic) {
                if (!uploadingDoc) HandleStoreDocument(e);
              } else if (currentStep === 5 + totalDynamic) {
                handleClose();
              } else {
                handleNextPage();
              }
            }}
          >
            {currentStep === 4 + totalDynamic ? (uploadingDoc ? "Soumission..." : t("submitButton")) : currentStep === 5 + totalDynamic ? t("cancelLabel") : t("nextButton")}
          </button>
        </div>
      </Offcanvas>
    </Fragment>
  );
};

export default AddfolderPanel;